import { ProductPodDomains } from './ProductPodDomains';
import { ProductPodInstallationDomains } from './ProductPodInstallationDomains';

export const GroupedDomains = {
  $ProductPod: ProductPodDomains,
  $ProductPodInstallation: ProductPodInstallationDomains
};
